import React from 'react';
import {
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import Root from './Root';
import {
  nonAuthRoutes,
  routeProps,
  routes,
} from './Constants';
import { AppNavigation } from './AppNavigation';
import { getToken } from '../utils/functions/authHelpers';

const Routes: React.FC = () => {
  const token = getToken();

  const createRoute = (route: routeProps) => {
    return {
      path: route.path,
      element: <route.element />,
    };
  };

  const createRoutes = (routes: routeProps[]) => {
    const routesList: {
      path: string;
      element: React.JSX.Element;
    }[] = [];
    routes.forEach((route) => {
      routesList.push(createRoute(route));
    });
    return routesList;
  };
  const routeConfig = [
    ...(token
      ? [
          {
            path: '/',
            element: <Root />,
            children: createRoutes(routes),
          },
        ]
      : nonAuthRoutes),
    {
      path: '*',
      element: <AppNavigation token={token} />,
    },
  ];

  const router = createBrowserRouter(routeConfig);
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
};

export default Routes;
